import React from "react";
import { useDeleteBrandMutation, useFetchBrandsQuery } from "../../../../store";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import ManagementToolbar from "../../managementShared/ManagementToolbar";
import {
  BRAND_DIALOG,
  CONFIRM_DIALOG,
} from "../../../../store/slices/utils/dialogEnum";
import { brandColumns } from "../utils/brandColumn";
import { useDispatch, useSelector } from "react-redux";
import { setBrand } from "../../../../store/slices/applicationManagement/managementSlice";
import {
  closeDialog,
  openDialog,
} from "../../../../store/slices/dialog/dialogSlice";
import CustomConfirmDialog from "../../../../components/shared/CustomConfirmDialog";
import BrandForm from "./BrandForm";
import {
  openErrorToast,
  openSuccessToast,
} from "../../../../store/slices/toast/toastSlice";
import ListHeader from "../../managementShared/ListHeader";

const Brand = () => {
  const dispatch = useDispatch();
  const { data: brands, isLoading: brandLoading } = useFetchBrandsQuery();
  const [deleteBrand, { isLoading: deleteLoading }] = useDeleteBrandMutation();
  const { brand } = useSelector((state) => state.managementSlice);
  const { brandDialogOpen } = useSelector((state) => state.dialogSlice);
  const handleUpdate = (brand) => {
    dispatch(setBrand(brand));
    dispatch(openDialog(BRAND_DIALOG));
  };
  const handleDelete = (brand) => {
    dispatch(setBrand(brand));
    dispatch(openDialog(CONFIRM_DIALOG));
  };
  const closeDelete = () => {
    dispatch(setBrand(null));
    dispatch(closeDialog(CONFIRM_DIALOG));
  };
  const postDelete = () => {
    deleteBrand(brand.id).then((res) => {
      if (res) {
        if (!res.data.isSuccess) {
          dispatch(openErrorToast(res.data.message));
        } else {
          dispatch(openSuccessToast("İşlem Tamamlandı"));
          closeDelete();
        }
      }
    });
  };
  return (
    <Box
      sx={{
        height: 300,
        width: "100%",
        marginTop: 10,
        flex: "flex",
        flexDirection: "column",
      }}
    >
      <ListHeader text="Markalar" />
      {brand && (
        <CustomConfirmDialog
          handleConfirm={postDelete}
          title="Marka Silme Onayı"
          text="Bu markayı silmek istediğinize emin misiniz?"
          isLoading={deleteLoading}
          handleClose={closeDelete}
        />
      )}
      {brandDialogOpen && <BrandForm />}
      <DataGrid
        rows={brands?.data || []}
        loading={brandLoading}
        disableColumnMenu
        columns={brandColumns(handleUpdate, handleDelete)}
        pageSizeOptions={[5, 10, 25, 50]}
        disableRowSelectionOnClick
        slots={{
          toolbar: (props) => (
            <ManagementToolbar {...props} dialogType={BRAND_DIALOG} />
          ),
        }}
        showToolbar
      />
    </Box>
  );
};

export default Brand;
